import * as actionTypes from './actionTypes'
import store from '../store'
import { pgaTypes } from '../formSections/pga/constantsPGA'
import { getTargetPGAForm } from '../api/getEntrySummaryData'
// import { convertFDAItems } from '../formSections/util/assignValues'
import { initializeFDA, initializeFDAWithTemplates } from './initializeValues'

export const toggleFDA = (
  merchandiseId,
  loading,
  fdaNumber,
  fdaDescription,
) => ({
  type: actionTypes.TOGGLE_FDA(fdaNumber),
  payload: {
    merchandiseId,
    loading,
    fdaNumber,
    fdaDescription
  }
})

// export function toggleFDAForm(
//   merchandiseId,
//   lineItemIndex,
//   fdaDescription,
//   additionalPGAOptions,
// ) {
//   // store.dispatch(toggleFDA(merchandiseId, true, lineItemIndex, fdaDescription))
//   getTargetPGAForm(pgaTypes.DISCLAIM_PGA,null,merchandiseId,additionalPGAOptions)
//     .then(response => {
//       console.log('responxse: ', response);
//       return store.dispatch(
//         initializeFDAWithTemplates(
//           merchandiseId,
//           convertFDAItems(response.data.eventMessage.pgaItems, merchandiseId),
//           response.data.eventMessage.templates
//         )
//       )
//     })
//     .catch(err => {
//       console.error('FDA Error', err)
//       let error = {
//         FDAError: err
//       }
//       return store.dispatch(
//         initializeFDA(
//           merchandiseId,
//           {
//             error: `ERROR: Could not retrieve FDA Certification for the associated HTS and Merchandise ID ${merchandiseId} ${error}`
//           })
//       )
//     })
// }

// export function copyFDAPgaItems(pgaGuid, lineItemIndex, merchandiseId, pgaItems) {
//     return {
//     type: actionTypes.COPY_FDA_FIELD(lineItemIndex),
//     lineItemIndex,
//     merchandiseId,
//     payload : convertFDAItems(pgaGuid, pgaItems,merchandiseId),
//     pgaItems
//   }
// }


export function updateFDAField(lineItemIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_FDA_FIELD(lineItemIndex),
    payload,
    field
  }
}

export function saveFDAField(merchandiseId, lineItemIndex, field, payload) {
  return {
    type: actionTypes.SAVE_FDA_FIELD(lineItemIndex),
    field,
    payload,
    merchandiseId
  }
}
